import compileSymbols from '~/utils/compileSymbols';
var types = ['UPDATE_LAB_MODE'];
export default compileSymbols(types, 'labMode');
